export const orderConfig = {
    configuration: false,
    disablePage: true,
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '批量选择',
                value: 'batchQueryValue',
                type: 'input',
                placeholder: '请输入客户商品编码',
                selectConfig: {
                    width: '100px',
                    prop: 'batchQueryKey',
                    value: 'customerItemCode',
                    option: [
                        { label: '客户商品编码', prop: 'customerItemCode', placeholder: '请输入客户商品编码' },
                        { label: '商品编码', prop: 'itemCode', placeholder: '请输入商品编码' },
                        { label: '商品名称', prop: 'itemName', placeholder: '请输入商品名称' },
                        { label: '套机编码', prop: 'itemSuiteCode', placeholder: '请输入套机编码' },
                        { label: '品牌', prop: 'brandName', placeholder: '请输入品牌' }
                    ]
                },
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        leftOperation: true,
        highlight: false,
        leftWidth: 80,
        selectBtn: false,
        columns: [
            {
                label: '序号',
                prop: 'tableIndex',
                width: '80px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                width: '240px',
                type: 'custom',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: '210px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '相关单号',
                prop: 'orderNo',
                width: '170px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '运单状态',
                prop: 'taskStatusName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '任务类型',
                prop: 'taskTypeName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '订单类型',
                prop: 'orderTypeName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '配送方式',
                prop: 'deliveryTypeName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '计费业务类型',
                prop: 'businessTypeName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '业务模式',
                prop: 'businessModeName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '仓库名称',
                prop: 'whName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '拣货状态',
                prop: 'wmsStatusName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户',
                prop: 'customerName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货人',
                prop: 'receiverName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货电话',
                prop: 'receiverMobile',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户详细收货地址',
                prop: 'receiverDetailAddr',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '计划数量',
                prop: 'planQty',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实扫数量',
                prop: 'rfActLoadQty',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发数量',
                prop: 'actQty',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '总包件数',
                prop: 'totalPkgQty',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发重量(kg)',
                prop: 'loadedGrossWeight',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发体积(m³)',
                prop: 'loadedVolume',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '拆单源任务号',
                prop: 'originTaskNo',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '拆单原因',
                prop: 'orderSplitReason',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '拆单源总数量',
                prop: 'originTotalQty',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '是否分拨',
                prop: 'distributionFlagName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '分拨仓库',
                prop: 'distributionWhName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收入计费前置',
                prop: 'billingIncomeAdvanceFlagName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '会计主体名称',
                prop: 'invoiceUnitName',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '要求发货时间',
                prop: 'requireOutTime',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '装车排序',
                prop: 'wlLoadSequence',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '是否已提货',
                prop: 'pickUpStatusName',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '装车完成时间',
                prop: 'ztbLoadDate',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '到车方式',
                prop: 'arrivalRegistrationTypeName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '到车时间',
                prop: 'actualArriveDate',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '围栏到车时间',
                prop: 'fenceArriveTime',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '发车确认时间',
                prop: 'departConfirmDate',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '围栏发车时间',
                prop: 'fenceDepartTime',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '抵达方式',
                prop: 'arrivalConfirmTypeName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '抵达时间',
                prop: 'arrivalTime',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '围栏抵达时间',
                prop: 'fenceArrivalTime',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '是否直控线路',
                prop: 'directControlFlagName',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '网点名称',
                prop: 'networkName',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货四级地址',
                prop: 'detailAddress',
                width: '260px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '最后修改人',
                prop: 'updateUserName',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                width: '140px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '套送号',
                prop: 'completeSetNo',
                width: '140px',
                defaultDisplay: true,
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '商品详情',
                size: 'mini',
                event: 'detail'
            }
        ]
    },
    searchTotalTitle: []
};

export const goodsConfig = {
    configuration: false,
    disablePage: true,
    searchList: {
        fieldTrim: true,
        searchTxt: [
            {
                name: '批量选择',
                value: 'batchQueryValue',
                type: 'input',
                placeholder: '请输入客户商品编码',
                selectConfig: {
                    width: '100px',
                    prop: 'batchQueryKey',
                    value: 'customerItemCode',
                    option: [
                        { label: '客户商品编码', prop: 'customerItemCode', placeholder: '请输入客户商品编码' },
                        { label: '商品编码', prop: 'itemCode', placeholder: '请输入商品编码' },
                        { label: '商品名称', prop: 'itemName', placeholder: '请输入商品名称' },
                        { label: '套机编码', prop: 'itemSuiteCode', placeholder: '请输入套机编码' },
                        { label: '品牌', prop: 'brandName', placeholder: '请输入品牌' }
                    ]
                },
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        leftOperation: false,
        highlight: false,
        leftWidth: 80,
        selectBtn: false,
        columns: [
            {
                label: '序号',
                prop: 'tableIndex',
                width: '80px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                width: '240px',
                type: 'custom',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: '210px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户',
                prop: 'customerName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '商品行号',
                prop: 'lineNo',
                width: '170px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '状态',
                prop: 'itemStatusName',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户商品编码',
                prop: 'customerItemCode',
                width: '100px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '商品名称',
                prop: 'itemName',
                width: '180px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '商品编码',
                prop: 'itemCode',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '套机编码',
                prop: 'itemSuiteCode',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '计划数量',
                prop: 'planQty',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发数量',
                prop: 'actQty',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '拆单源商品总数',
                prop: 'originTotalPlanQty',
                width: '200px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '单台方量(m³)',
                prop: 'volume',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '单台重量(kg)',
                prop: 'grossWeight',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发方量(m³)',
                prop: 'loadedVolume',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '包件数',
                prop: 'pkgQty',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '实发重量(kg)',
                prop: 'loadedGrossWeight',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '运单状态',
                prop: 'taskStatusName',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '仓库名称',
                prop: 'whName',
                width: '180px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName',
                width: '180px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '客户详细收货地址',
                prop: 'receiverDetailAddr',
                width: '180px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '是否分拨',
                prop: 'distributionFlagName',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '会计主体名称',
                prop: 'invoiceUnitName',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '到车时间',
                prop: 'actualArriveDate',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '发车确认时间',
                prop: 'departConfirmDate',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '抵达时间',
                prop: 'arrivalTime',
                width: '150px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '相关单号',
                prop: 'orderNo',
                width: '180px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '任务类型',
                prop: 'taskTypeName',
                width: '150px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '订单类型',
                prop: 'orderTypeName',
                width: '120px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '配送方式',
                prop: 'deliveryTypeName',
                width: '120px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '计费业务类型',
                prop: 'businessTypeName',
                width: '150px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '业务模式',
                prop: 'businessModeName',
                width: '120px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '拣货状态',
                prop: 'wmsStatusName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '收货人',
                prop: 'receiverName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '收货电话',
                prop: 'receiverMobile',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '分拨仓库',
                prop: 'distributionWhName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '收入计费前置',
                prop: 'billingIncomeAdvanceFlagName',
                width: '130px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '要求发货时间',
                prop: 'requireOutTime',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '装车排序',
                prop: 'wlLoadSequence',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '是否已提货',
                prop: 'pickUpStatusName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '实扫数量',
                prop: 'rfActLoadQty',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '实收数量',
                prop: 'realReceiveCount',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '包装规格',
                prop: 'cdcmPackageCode',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '包装单位',
                prop: 'unit',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '财务单号',
                prop: 'financeNo',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '商品分类',
                prop: 'itemClassName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '品牌',
                prop: 'cdcmBrand',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '件型',
                prop: 'itemSize',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '价格(元)',
                prop: 'price',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '批次',
                prop: 'batchCode',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '生产日期',
                prop: 'produceTimestamp',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '失效日期',
                prop: 'expireTimestamp',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '代贴标签数',
                prop: 'packingFlag',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '代贴标签文件地址',
                prop: 'defineStr1',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '装车完成时间',
                prop: 'ztbLoadDate',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '到车方式',
                prop: 'arrivalRegistrationTypeName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '围栏到车时间',
                prop: 'fenceArriveTime',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '围栏发车时间',
                prop: 'fenceDepartTime',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '抵达方式',
                prop: 'arrivalConfirmTypeName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '围栏抵达时间',
                prop: 'fenceArrivalTime',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '是否直控线路',
                prop: 'directControlFlag',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '计划方量(m³)',
                prop: 'planVolume',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '网点名称',
                prop: 'networkName',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '收货四级地址',
                prop: 'detailAddress',
                width: '260px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '库区',
                prop: 'itemZoneName',
                width: '160px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '库区编码',
                prop: 'itemZoneCode',
                width: '120px',
                defaultDisplay: true,
                sort: true
            },
            {
                label: '最后修改人',
                prop: 'updateUserName',
                width: '140px',
                defaultDisplay: false,
                sort: true
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                width: '140px',
                defaultDisplay: false,
                sort: true
            }
        ],
        action: []
    },
    searchTotalTitle: []
};

export const tableProp = [
    {
        label: '商品行号',
        prop: 'lineNo',
        width: '100px'
    },
    {
        label: '客户商品编码',
        prop: 'customerItemCode',
        width: '200px'
    },
    {
        label: '商品编码',
        prop: 'itemCode',
        width: '180px'
    },
    {
        label: '商品名称',
        prop: 'itemName',
        width: '230px'
    },
    {
        label: '套机编码',
        prop: 'itemSuiteCode',
        width: '180px'
    },
    {
        label: '状态',
        prop: 'itemStatusName',
        width: '100px'
    },
    {
        label: '品牌',
        prop: 'cdcmBrand',
        width: '100px'
    },
    {
        label: '计划数量',
        prop: 'planQty',
        width: '100px'
    },
    {
        label: '实发数量',
        prop: 'actQty',
        width: '100px'
    },
    {
        label: '实扫数量',
        prop: 'rfActLoadQty',
        width: '100px'
    },
    {
        label: '实收数量',
        prop: 'realReceiveCount',
        width: '100px'
    },
    {
        label: '包装规格',
        prop: 'cdcmPackageCode',
        width: '100px'
    },
    {
        label: '包装单位',
        prop: 'unit',
        width: '100px'
    },
    {
        label: '单台方量(m³)',
        prop: 'volume',
        width: '100px'
    },
    {
        label: '单台重量(kg)',
        prop: 'grossWeight',
        width: '100px'
    },
    {
        label: '财务单号',
        prop: 'financeNo',
        width: '110px'
    },
    {
        label: '商品分类',
        prop: 'itemClassName',
        width: '110px'
    },
    {
        label: '件型',
        prop: 'itemSize',
        width: '100px'
    },
    {
        label: '价格(元)',
        prop: 'price',
        width: '100px'
    },
    {
        label: '批次',
        prop: 'batchCode',
        width: '100px'
    },
    {
        label: '生产日期',
        prop: 'produceTimestamp',
        width: '100px'
    },
    {
        label: '失效日期',
        prop: 'expireTimestamp',
        width: '110px'
    },
    {
        label: '代贴标签数',
        prop: 'labelNumber',
        width: '200px'
    },
    {
        label: '代贴标签文件地址',
        prop: 'labelFile',
        width: '200px'
    }
];
